import { NumberInput, Select } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IFormInputSpecFileList } from 'pages/revisions-module/template-editor/editors/form/types';
import { useEffect } from 'react';

/**
 * Common MIME type options for file uploads.
 */
const MIME_TYPE_OPTIONS = [{ value: 'image/*', label: 'Obrázky' }];

/**
 * Sub-form for file list input properties.
 */
export default function FileListInputPropertiesSubForm({ form }: { form: UseFormReturnType<IFormInputSpecFileList> }) {
  // Set default value for accept if not set to 'image/*'
  useEffect(() => {
    if (form.values.accept) {
      form.setFieldValue('accept', 'image/*');
    }
  }, [form]);

  // Set default value for maxFiles if not set
  useEffect(() => {
    if (!form.values.maxFiles) {
      form.setFieldValue('maxFiles', 1);
    }
  }, [form]);

  return (
    <>
      <NumberInput
        label="Maximálny počet súborov"
        required
        min={1}
        max={999}
        defaultValue={1}
        {...form.getInputProps('maxFiles')}
      />
      <Select
        size="sm"
        label="Typ súborov"
        required
        data={MIME_TYPE_OPTIONS}
        searchable
        {...form.getInputProps('accept')}
      />
    </>
  );
}
